export const addressFilter = (addresses, searchTerm) => {
  if (!searchTerm) return addresses

  const lowercaseSearch = searchTerm.toLowerCase()

  return addresses.reduce((acc, patrimony) => {
    const patrimoinyMatches = patrimony.label.toLowerCase().includes(lowercaseSearch)

    if (patrimoinyMatches) {
      acc.push(patrimony)
      return acc
    }

    const filteredSectors = patrimony.sectors.reduce((sectorAcc, sector) => {
      const sectorMatches = sector.label.toLowerCase().includes(lowercaseSearch)

      if (sectorMatches) {
        sectorAcc.push(sector)
        return sectorAcc
      }

      const filteredAgencies = sector.agencies.filter((agency) => agency.label.toLowerCase().includes(lowercaseSearch))

      if (filteredAgencies.length > 0) {
        sectorAcc.push({
          ...sector,
          agencies: filteredAgencies,
        })
      }
      return sectorAcc
    }, [])

    if (filteredSectors.length > 0) {
      acc.push({
        ...patrimony,
        sectors: filteredSectors,
      })
    }
    return acc
  }, [])
}

export default addressFilter
